import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Service from '@/pages/service'
import Cookies from '@/pages/cookies'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'Index',
    component: Index
  }, {
    path: '/:service',
    name: 'Service',
    component: Service
  }, {
    path: '/cookies',
    name: 'Cookies',
    component: Cookies
  }, {
    path: '*',
    redirect: '/'
  }],
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js